import { render, staticRenderFns } from "./reviewOfApplyForHouse.vue?vue&type=template&id=524437c2&scoped=true&"
import script from "./reviewOfApplyForHouse.vue?vue&type=script&lang=js&"
export * from "./reviewOfApplyForHouse.vue?vue&type=script&lang=js&"
import style0 from "./reviewOfApplyForHouse.vue?vue&type=style&index=0&id=524437c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524437c2",
  null
  
)

export default component.exports